<template>
  <div id="user">
    <p class="title"><label @click="$router.push('/user/home')">我的 / </label>账号管理</p>
    <div class="table">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="用户信息" name="first">
        <div class="flex">
        <div class="left">
          <p>
            <span>公司名称:</span>
            <span>{{userData.company}}</span>
          </p>
          <p>
            <span>用户名:</span>
            <span>{{userData.username}}</span>
          </p>
          <p>
            <span>注册地址:</span>
            <span>{{userData.address}}</span>
          </p>
          <p>
            <span>联系人:</span>
            <el-input size="small" v-model="form.linkman"></el-input>
          </p>
          <p>
            <span>联系电话:</span>
            <el-input size="small" v-model="form.telphone"></el-input>
          </p>
          <p>
            <span>邮箱:</span>
            <el-input size="small" v-model="form.email"></el-input>
          </p>
          <p>
            <span>授信额度(元):</span>
            <span>{{userData.beforehandLimit}}</span>
          </p>
        </div>
        <div class="right">
          <p>
            <span>公司编号:</span>
            <span>{{userData.idNumber}}</span>
          </p>
          <p>
            <span style="vertical-align: top;">企业图标:</span>
            <!-- <img :src="userData.idPath" width="400px" alt /> -->
            <el-upload
              style="display:inline-block"
              class="avatar-uploader"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <img v-if="form.idPath" :src="form.idPath" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </p>
        </div>
      </div>
      <el-divider></el-divider>
      <div class="btn-box" style="text-align: center">
        <button class="common-btn" @click="changeInfo">确认提交</button>
      </div>

      </el-tab-pane>
      <el-tab-pane label="修改密码" name="second">
        <div class="flex">
        <div class="left">
          <el-form
            :rules="rules"
            ref="form"
            label-position="right"
            label-width="30%"
            :model="form"
          >
            <el-form-item label="原始密码:" prop="password">
              <el-input type="password" v-model="form.password" placeholder="请输入原始密码" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="新密码:" prop="newPassword">
              <el-input type="password" v-model="form.newPassword" placeholder="请输入新密码" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="确认密码:" prop="repwd">
              <el-input type="password" v-model="form.repwd" placeholder="请再次输入密码" autocomplete="off"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <el-divider></el-divider>
      <div class="btn-box" style="text-align: center">
        <button class="common-btn" @click="changePassword('form')">确认提交</button>
      </div>
      </el-tab-pane>
    </el-tabs>
    </div>
  </div>
</template>

<script>
import {
  upload,
  // fileUrl,
  queryById,
  userEdit,
  modifyPassword
} from "@/js/api";
import { mapActions } from "vuex";
import { IP } from "@/js/public";
export default {
  name: "manage",
  computed: {},
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码！"));
      } else {
        if(value.length < 8){
          callback(new Error("密码必须为8-16位，字母大小写、数字、特殊符号组合！"));
        }
        if(!/^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,16}$/.test(value)) {
          callback(new Error("密码必须为8-16位，字母大小写、数字、特殊符号组合！"));
        }

        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码！"));
      } else if (value !== this.form.newPassword) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      // fileUrl,
      activeName: 'first',
      labelWidth: "120px",
      addModal: false,
      tableData: [],
      userData: {},
      form: {
        parentId: this.$store.state.user.info.id,
        userType: 2,
        username: "",
        password: "",
        newPassword: "",
        repwd: ""
      },
      rules: {
        username: [
          { required: true, message: "请输入账号名", trigger: "blur" },
          { min: 5, message: "长度在 5 个字符以上", trigger: "blur" }
        ],
        password: [
          { required: true, message: "请输入原始密码", trigger: "blur" }
        ],
        newPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { validator: validatePass, trigger: "blur" }
        ],
        repwd: [
          { required: true, message: "请再次输入密码", trigger: "blur" },
          { validator: validatePass2, trigger: "blur" }
        ],
        telphone: [
          { required: true, message: "请输入11位手机号", trigger: "change" },
          { min: 11, max: 11, message: "请输入11位手机号", trigger: "blur" }
        ]
      },
      isEdit: false,
      url: "sys/user/updatePassword",
    };
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions(["Login", "Logout", "PhoneLogin"]),
    uploadFile(e) {
      var formData = new FormData();
      formData.set("file", e.file);
      formData.set("type", "commodity");
      upload(formData).then(res => {
        if (res.code == "200") {
          this.$message.warn("图片上传成功！");
          e.onSuccess();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleAvatarSuccess(res, file) {
      if (res.code == 200) {
        this.form.idPath = IP + "/kufeng-admin/" + res.result;
        this.$forceUpdate();
      }
      // this.form.idPath = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      // const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      // if (!isJPG) {
      //   this.$message.error("上传头像图片只能是 JPG 格式!");
      // }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    getData() {
      queryById({
        id: this.$store.state.user.info.id
      }).then(res => {
        if (res.code == 0) {
          this.userData = res.result || [];
          this.form = Object.assign({}, res.result);
          this.form.password = null
        }
      });
    },
    edit(item) {
      this.isEdit = true;
      this.form = item;
      this.addModal = true;
    },
    changePassword(formName) {
      this.$refs[formName].validate((valid) => {
          if (valid) {
            modifyPassword({username:this.form.username, oldpassword:this.form.password,
            password:this.form.newPassword, confirmpassword:this.form.repwd }).then(res => {
              if (res.code == 200) {
                 this.$message.success(res.message);
                 this.logout()
              } else {
                 this.$message.error(res.message);
              }
             });
          } else {
            return false;
          }
        });
    },
    changeInfo() {
      userEdit(this.form).then(res => {
        if (res.code == 200) {
          this.$message.success(res.message);
          this.getData();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    logout: function() {
      this.Logout().then(res => {
        if (res.data.code == 200) {
          this.$message.success(res.data.message);
          this.$router.push("/");
        } else {
          this.$message.error(res.message);
        }
      });
    },
  }
};
</script>

<style >
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: orange;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
<style lang="less" scoped>
.title {
  margin-bottom: 20px;
  padding-left: 20px;
  font-size: 15px;
  line-height: 60px;
  background: #fff;
  border-bottom: solid 1px #ccc;
  span {
    float: right;
    margin-right: 20px;

    font-size: 12px;
  }
}
.common-search-box {
  padding: 12px 20px 0;
  background: #fff;
  .el-input {
    width: 140px;
  }
}
.table {
  padding: 20px;
  background: #fff;
  .flex {
    display: flex;
    > div {
      flex: 1;
    }

    p {
      padding: 10px 0;
      // line-height: 40px;
    }
    span:first-child {
      display: inline-block;
      width: 120px;
      text-align: right;
      margin-right: 12px;
    }
    .el-input {
      width: 240px;
    }
  }
}
</style>
